import { render } from "./ConversationReplyTo.vue?vue&type=template&id=489fce32"
import script from "./ConversationReplyTo.vue?vue&type=script&lang=js"
export * from "./ConversationReplyTo.vue?vue&type=script&lang=js"
script.render = render

export default script